/**
 * Populate a form's inputs with specified data
 *
 * @param {element} form DOM element
 * @param {object} data form data
 */
export function populateForm(form, data) {
  // eslint-disable-next-line compat/compat
  let elements = Array.from(form.elements)

  elements.forEach(element => {
    switch (element.type) {
      case "date": {
        element.value = data[element.name] || null
        break
      }
      case "radio": {
        element.checked = element.value == data[element.name]
        break
      }
      case "select-multiple": {
        // standard html control
        const selectedValues = data[element.name] || []
        element.querySelectorAll("option").forEach(option => {
          option.selected = selectedValues.includes(option.value)
        })
        // fancy selectr dropdowns
        if (element.selectr) {
          element.selectr.eventsDisabled = true
          element.selectr.clear()
          element.selectr.setValue(selectedValues)
          element.selectr.eventsDisabled = false
        }
        break
      }

      case "checkbox": {
        const values = data[element.name]
        if (Array.isArray(values)) {
          element.checked = values.includes(element.value)
        } else {
          element.checked = values == element.value
        }
        break
      }

      default: {
        element.value = data[element.name] || null
        break
      }
    }
  })
}

/**
 * Form values as an object
 *
 * @param {element} form
 */
export function formToObject(form) {
  const data = {}
  const formData = new FormData(form)

  formData.forEach((value, key) => {
    if (!data.hasOwnProperty(key)) {
      data[key] = value
      return
    }
    if (!Array.isArray(data[key])) {
      data[key] = [data[key]]
    }
    data[key].push(value)
  })
  return data
}

/**
 * Serialize a form to queryString
 *
 * @param {element} form
 */
export function serializeForm(form) {
  const data = new formToObject(form)
  return objectToQueryString(data)
}

/**
 * Convert specified object to a queryString
 *
 * @param {string} queryString
 */
export function objectToQueryString(obj) {
  // eslint-disable-next-line compat/compat
  const entries = [...Object.entries(obj)] // obj to array
  return entries.map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`).join("&")
}

/**
 * Convert specified queryString to an object
 *
 * @param {string} queryString
 */
export function queryStringToObject(queryString) {
  const obj = {}
  // eslint-disable-next-line compat/compat
  const urlParams = new URLSearchParams(queryString)

  urlParams.forEach((value, key) => {
    const isArray = key.endsWith("[]")
    const baseKey = isArray ? key.slice(0, -2) : key

    // Allow multiple values for the same key with comma separation
    const values = value.includes(",") ? value.split(",") : [value]

    if (isArray) {
      if (obj[baseKey]) {
        obj[baseKey] = obj[baseKey].concat(values)
      } else {
        obj[baseKey] = values
      }
    } else {
      obj[baseKey] = values.length > 1 ? values : values[0]
    }
  })

  return obj
}

export default { populateForm, formToObject, serializeForm, objectToQueryString, queryStringToObject }
